module.exports = __webpack_public_path__ + "img/img_24@2x.8a4357f2.png";